export default {
  cardHeaderStyle: {
    fontFamily: "Roboto",
    margin: "1rem 0 0 1rem",
    fontSize: "1.3rem",
  },

  imageStyle: {
    margin: "1rem 0 0 0",
    width: "2rem",
    height: "2rem",
  },
};
